import React, { useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { theme } from '../styles/theme';

const slideIn = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const ToastContainer = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 10000;
  animation: ${slideIn} 0.3s ease-out;
`;

const ToastCard = styled.div`
  background: ${props => props.type === 'success' ? '#10b981' : '#ef4444'};
  color: white;
  padding: ${theme.spacing.md} ${theme.spacing.lg};
  border-radius: ${theme.borderRadius.lg};
  box-shadow: ${theme.shadows.lg};
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm};
  min-width: 300px;
  max-width: 400px;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 18px;
  margin-left: auto;
  padding: 0;
  
  &:hover {
    opacity: 0.8;
  }
`;

const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <ToastContainer>
      <ToastCard type={type}>
        <span>{type === 'success' ? '✓' : '✗'}</span>
        <span>{message}</span>
        <CloseButton onClick={onClose}>×</CloseButton>
      </ToastCard>
    </ToastContainer>
  );
};

export default Toast;